/* PAINTRANGER - Candy/Decay-Schalter.

   Candy ist immer der Ausgangszustand. Ein Klick schaltet fuer ein paar
   Sekunden in den Decay-Modus: Farben kippen ins Schimmelige, Risse,
   Schleim, eine Zombiehand, ein Lutscher am Faden, eine Fledermaus
   und ein paar Fliegen kommen dazu. Danach kommt die Seite von selbst zurueck. Ein
   zweiter Klick beendet ihn sofort. Beliebig oft wiederholbar.

   Die Deko wird beim Einschalten erzeugt und beim Ausschalten wieder
   vollstaendig aus dem DOM entfernt. Sie nimmt keine Klicks an und liegt
   unter der Kopfzeile und unter dem Warenkorb.

   Nichts davon wird gespeichert. Beim naechsten Seitenaufruf ist wieder
   Candy, so wie es sein soll.
*/
(function () {
  'use strict';

  var DEFAULTS = {
    label: 'DECAY',
    duration: 8000,
    showNote: true,
    note: 'Everything ripens. Everything rots.',
    inMenu: false,
    props: ['cracks', 'drips', 'hand', 'candy', 'bat', 'flies']
  };

  var config = readConfig();
  var root = document.documentElement;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var backTimer = null;
  var noteTimer = null;
  var note = null;
  var props = null;
  var drips = null;
  var hanger = null;
  var bat = null;

  if (config.inMenu) root.classList.add('pf-decay-in-menu');

  function readConfig() {
    var out = {
      label: DEFAULTS.label,
      duration: DEFAULTS.duration,
      showNote: DEFAULTS.showNote,
      note: DEFAULTS.note,
      inMenu: DEFAULTS.inMenu,
      props: DEFAULTS.props.slice()
    };
    var node = document.getElementById('pf-decay-config');
    if (!node) return out;
    try {
      var raw = JSON.parse(node.textContent);
      if (typeof raw.label === 'string' && raw.label.trim()) out.label = raw.label.trim();
      if (typeof raw.duration === 'number' && raw.duration > 0) out.duration = raw.duration;
      if (typeof raw.showNote === 'boolean') out.showNote = raw.showNote;
      if (typeof raw.note === 'string') out.note = raw.note.trim();
      if (typeof raw.inMenu === 'boolean') out.inMenu = raw.inMenu;
      if (raw.props && raw.props.length !== undefined) out.props = raw.props;
    } catch (e) {}
    return out;
  }

  function wants(name) {
    return config.props.indexOf(name) > -1;
  }

  /* ---------------------------------------------------------------- */
  /* Die Deko. Alles selbst gezeichnet, im Stil der Seite.             */
  /* ---------------------------------------------------------------- */

  var INK = '#0b0f0a';
  var MOULD = '#4a5f28';
  var FLESH = '#7f9a63';
  var BONE = '#e8e2cf';
  var ROT = '#8d4f63';

  function svg(viewBox, inner) {
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' +
      viewBox +
      '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">' +
      inner +
      '</svg>'
    );
  }

  var ART = {
    crack: function () {
      return svg(
        '0 0 260 260',
        '<g fill="none" stroke="' +
          BONE +
          '" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round">' +
          '<path stroke-width="5" d="M0 0l54 42-19 27 48 35-15 31 42 27 6 34"/>' +
          '<path stroke-width="3.5" d="M54 42l38-26 30 9 22-14"/>' +
          '<path stroke-width="3" d="M83 104l40 8 20 28 34 8"/>' +
          '<path stroke-width="4" d="M0 0l26 68-32 22"/>' +
          '<path stroke-width="2.5" d="M35 69l-26 16"/>' +
          '<path stroke-width="2.5" d="M110 136l-8 30 14 22"/>' +
          '</g>'
      );
    },

    hand: function () {
      return svg(
        '0 0 130 170',
        '<g stroke="' +
          INK +
          '" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">' +
          '<path fill="' +
          FLESH +
          '" d="M34 170v-66c0-10 7-17 16-17h30c9 0 16 7 16 17v66z"/>' +
          '<path fill="' +
          FLESH +
          '" d="M41 92V52a6 6 0 0 1 12 0v40z"/>' +
          '<path fill="' +
          FLESH +
          '" d="M56 88V36a6 6 0 0 1 12 0v52z"/>' +
          '<path fill="' +
          FLESH +
          '" d="M71 90V46a6 6 0 0 1 12 0v44z"/>' +
          '<path fill="' +
          FLESH +
          '" d="M86 98V64a6 6 0 0 1 12 0v34z"/>' +
          '<path fill="' +
          FLESH +
          '" d="M34 118c-9-6-20 0-18 10 2 9 11 13 18 9z"/>' +
          '<path fill="' +
          ROT +
          '" d="M30 150h70v20H30z"/>' +
          '<path fill="none" stroke-width="3" d="M52 128l14 6M74 140l12-5M46 108l10 4"/>' +
          '<path fill="' +
          BONE +
          '" stroke-width="3" d="M96 150h10v12H96z"/>' +
          '</g>'
      );
    },

    hanger: function () {
      return svg(
        '0 0 110 300',
        '<path fill="none" stroke="' +
          BONE +
          '" stroke-opacity="0.7" stroke-width="2" d="M55 0v148"/>' +
          '<circle cx="55" cy="150" r="4" fill="' +
          BONE +
          '"/>' +
          '<g stroke="' +
          INK +
          '" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">' +
          '<path fill="none" stroke="' +
          BONE +
          '" stroke-width="5" d="M55 152v46"/>' +
          '<circle cx="55" cy="228" r="32" fill="' +
          ROT +
          '"/>' +
          '<path fill="none" stroke="' +
          BONE +
          '" stroke-width="3.6" d="M55 228a3 3 0 0 1 6 0a6 6 0 0 1-12 0a9 9 0 0 1 18 0a12 12 0 0 1-24 0a15 15 0 0 1 30 0a18 18 0 0 1-36 0a21 21 0 0 1 42 0"/>' +
          '<path fill="' +
          INK +
          '" stroke="none" d="M79 206a32 32 0 0 1 7 24l-22-12z"/>' +
          '</g>' +
          '<g fill="' +
          MOULD +
          '" stroke="none">' +
          '<path d="M45 257c2 11 5 17 4 25a4.6 4.6 0 0 1-9 0c-1-8 2-16 5-25z"/>' +
          '<path d="M66 256c2 15 6 23 5 33a5 5 0 0 1-10 0c-1-10 3-20 5-33z"/>' +
          '<ellipse cx="66" cy="296" rx="3.6" ry="4.6"/>' +
          '</g>'
      );
    },

    bat: function () {
      return svg(
        '0 0 120 60',
        '<g class="pf-decay-bat__wings" fill="' +
          INK +
          '">' +
          '<path d="M53 28C42 13 26 11 9 17c9 5 11 13 9 21 7-5 15-5 21 0z"/>' +
          '<path d="M67 28C78 13 94 11 111 17c-9 5-11 13-9 21-7-5-15-5-21 0z"/>' +
          '</g>' +
          '<g fill="' +
          INK +
          '">' +
          '<ellipse cx="60" cy="33" rx="8" ry="12"/>' +
          '<circle cx="60" cy="20" r="7"/>' +
          '<path d="M53 16l-2-10 8 6zM67 16l2-10-8 6z"/>' +
          '</g>' +
          '<g fill="' +
          BONE +
          '">' +
          '<circle cx="57" cy="19" r="1.6"/>' +
          '<circle cx="63" cy="19" r="1.6"/>' +
          '</g>'
      );
    },

    fly: function () {
      return svg(
        '0 0 24 24',
        '<g>' +
          '<ellipse cx="12" cy="13" rx="4.5" ry="3.4" fill="' +
          INK +
          '"/>' +
          '<ellipse cx="6" cy="8" rx="4" ry="2.2" fill="' +
          BONE +
          '" fill-opacity="0.75" transform="rotate(-25 6 8)"/>' +
          '<ellipse cx="18" cy="8" rx="4" ry="2.2" fill="' +
          BONE +
          '" fill-opacity="0.75" transform="rotate(25 18 8)"/>' +
          '</g>'
      );
    }
  };

  function prop(className, markup) {
    var el = document.createElement('span');
    el.className = 'pf-decay-prop ' + className;
    el.innerHTML = markup;
    return el;
  }

  function buildProps() {
    removeProps();
    props = document.createElement('div');
    props.className = 'pf-decay-props';
    props.setAttribute('aria-hidden', 'true');

    // Die uebrige Deko bleibt am Bildschirm kleben und faengt erst unter
    // der Kopfzeile an, damit Menue, Suche und Warenkorb frei bleiben.
    var header = document.querySelector('.section-header, .header-wrapper, header');
    var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    props.style.setProperty('--pf-decay-top', top + 'px');

    if (wants('cracks')) {
      ['tl', 'tr', 'bl', 'br'].forEach(function (corner) {
        props.appendChild(
          prop('pf-decay-prop--crack pf-decay-prop--crack-' + corner, ART.crack())
        );
      });
    }
    if (wants('hand')) props.appendChild(prop('pf-decay-prop--hand', ART.hand()));
    if (wants('flies') && !reduceMotion) {
      [1, 2, 3, 4, 5].forEach(function (n) {
        props.appendChild(prop('pf-decay-prop--fly pf-decay-prop--fly-' + n, ART.fly()));
      });
    }

    document.body.appendChild(props);

    // Der Schleim haengt am oberen Rand der Seite, nicht am Bildschirm.
    // Er beginnt ganz oben und scrollt mit weg.
    if (wants('drips')) {
      drips = document.createElement('div');
      drips.className = 'pf-decay-drips';
      drips.setAttribute('aria-hidden', 'true');
      // Das Theme blendet leere div-Elemente aus (div:empty). Der Schleim
      // steckt im Hintergrundbild, deshalb bekommt er ein leeres Kind,
      // damit er nicht als leer gilt.
      drips.appendChild(document.createElement('span'));
      document.body.appendChild(drips);
    }

    // Der Lutscher haengt an einem Faden vom oberen Bildschirmrand.
    if (wants('candy')) {
      hanger = document.createElement('div');
      hanger.className = 'pf-decay-hanger';
      hanger.setAttribute('aria-hidden', 'true');
      hanger.innerHTML = ART.hanger();
      document.body.appendChild(hanger);
    }

    // Die Fledermaus fliegt nur, wenn Bewegung erwuenscht ist.
    if (wants('bat') && !reduceMotion) {
      bat = document.createElement('div');
      bat.className = 'pf-decay-bat';
      bat.setAttribute('aria-hidden', 'true');
      bat.innerHTML = ART.bat();
      document.body.appendChild(bat);
    }
  }

  function removeProps() {
    [props, drips, hanger, bat].forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    props = null;
    drips = null;
    hanger = null;
    bat = null;
  }

  /* ---------------------------------------------------------------- */
  /* Umschalten                                                        */
  /* ---------------------------------------------------------------- */

  function isOn() {
    return root.classList.contains('pf-decay');
  }

  function sync() {
    var on = isOn() ? 'true' : 'false';
    var buttons = document.querySelectorAll('.pf-decay-toggle');
    Array.prototype.forEach.call(buttons, function (button) {
      button.setAttribute('aria-pressed', on);
    });
  }

  function removeNote() {
    window.clearTimeout(noteTimer);
    noteTimer = null;
    if (!note) return;
    var old = note;
    note = null;
    if (reduceMotion) {
      if (old.parentNode) old.parentNode.removeChild(old);
      return;
    }
    old.classList.remove('pf-decay-note--in');
    window.setTimeout(function () {
      if (old.parentNode) old.parentNode.removeChild(old);
    }, 400);
  }

  function showNote() {
    if (!config.showNote || !config.note) return;
    removeNote();

    note = document.createElement('p');
    note.className = 'pf-decay-note';
    note.setAttribute('role', 'status');
    note.textContent = config.note;
    document.body.appendChild(note);

    if (!reduceMotion) {
      // Erst im naechsten Bild einblenden, sonst gibt es keinen Uebergang.
      window.requestAnimationFrame(function () {
        if (note) note.classList.add('pf-decay-note--in');
      });
    }

    noteTimer = window.setTimeout(removeNote, 2800);
  }

  function enable() {
    if (isOn()) return;
    root.classList.add('pf-decay');
    buildProps();
    sync();
    showNote();

    window.clearTimeout(backTimer);
    backTimer = window.setTimeout(disable, config.duration);
  }

  function disable() {
    window.clearTimeout(backTimer);
    backTimer = null;
    if (!isOn()) return;
    root.classList.remove('pf-decay');
    removeProps();
    sync();
    removeNote();
  }

  function toggle() {
    if (isOn()) {
      disable();
    } else {
      enable();
    }
  }

  function createButton(variant) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'pf-decay-toggle pf-decay-toggle--' + variant;
    button.setAttribute('aria-pressed', isOn() ? 'true' : 'false');
    button.textContent = config.label;
    button.addEventListener('click', toggle);
    return button;
  }

  function mount() {
    // Kopfzeile: neben die vorhandenen Symbole.
    var iconBars = document.querySelectorAll('.header__icons');
    Array.prototype.forEach.call(iconBars, function (bar) {
      if (bar.querySelector('.pf-decay-toggle')) return;
      var cart = bar.querySelector('.header__icon--cart');
      bar.insertBefore(createButton('header'), cart || null);
    });

    // Nur wenn gewuenscht zusaetzlich in die mobile Menue-Schublade.
    if (config.inMenu) {
      var drawers = document.querySelectorAll('.menu-drawer__navigation');
      Array.prototype.forEach.call(drawers, function (drawer) {
        if (drawer.querySelector('.pf-decay-toggle')) return;
        drawer.appendChild(createButton('drawer'));
      });
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  // Der Theme-Editor zeichnet Abschnitte neu.
  document.addEventListener('shopify:section:load', mount);

  // Beim Verlassen der Seite alles sauber zuruecksetzen.
  window.addEventListener('pagehide', function () {
    window.clearTimeout(backTimer);
    window.clearTimeout(noteTimer);
    removeProps();
    removeNote();
  });
})();
